// src/pages/admin/AdminStats.jsx
import React, { useEffect, useState } from 'react';
import PageLayout from '../components/PageLayout';
import { CONFIG } from '../config/config';
import toast from 'react-hot-toast';


export default function AdminStats() {
  const [views, setViews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingKey, setDownloadingKey] = useState(null);

  const API = (CONFIG.API_URL || '/api').replace(/\/+$/, '');
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');

  useEffect(() => {
    fetchViews();
  }, []);

  const fetchViews = async () => {
    try {
      const res = await fetch(`${API}/admin/stats/views`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Impossible de charger les vues');
      const data = await res.json();
      setViews(data);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (key, label) => {
    setDownloadingKey(key);
    try {
      const res = await fetch(`${API}/admin/stats/export/${key}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.message || 'Échec du téléchargement');
      }

      // Récupération du blob CSV et déclenchement du téléchargement
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${key}_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      toast.success(`Export de "${label}" réussi`);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setDownloadingKey(null);
    }
  };

  return (
    <PageLayout title="Statistiques & Exports">
      <div className="max-w-4xl mx-auto py-4 space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Export des données statistiques</h1>
          <p className="text-sm text-slate-500 mt-1">
            Téléchargez les rapports bruts au format CSV pour analyse
          </p>
        </div>

        {loading ? (
          <div className="text-center py-8 text-slate-500">Chargement des vues...</div>
        ) : views.length === 0 ? (
          <div className="text-center py-8 text-slate-400">Aucune vue statistique configurée.</div>
        ) : (
          <div className="grid grid-cols-1 gap-4">
            {views.map((v) => (
              <div
                key={v.key}
                className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 bg-white border border-slate-200 rounded-xl shadow-sm hover:border-slate-300 transition"
              >
                <div>
                  <h3 className="font-semibold text-slate-800">{v.label}</h3>
                  {v.description && (
                    <p className="text-sm text-slate-500 mt-0.5">{v.description}</p>
                  )}
                </div>

                <button
                  onClick={() => handleDownload(v.key, v.label)}
                  disabled={downloadingKey === v.key}
                  className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-slate-800 text-white rounded-lg text-sm font-medium hover:bg-slate-700 disabled:opacity-50 transition shrink-0"
                >
                  {downloadingKey === v.key ? (
                    <span>Génération...</span>
                  ) : (
                    <>
                      <span className="i-tabler-file-spreadsheet h-5 w-5" />
                      <span>Télécharger le CSV</span>
                    </>
                  )}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </PageLayout>
  );
}
